module.exports = __webpack_public_path__ + "img/bpm.f86fd67e.svg";